import '../../style/login/style-app-login.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
import { useEffect, useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import { loginConnector } from '../../server/connector/loginConnector'

function AppResetPassword() {
	const [resettingPassword, setResettingPassword] = useState<boolean>(false)
	const [resetFailed, setResetFailed] = useState<boolean>(false)

	const [email, setEmail] = useState<string>('')

	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)

	useEffect(() => {
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked == true) {
			// confirm a user is logged in
			if (userStateData.loggedIn == true) {
				window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
			} 
		}
	}, [loginChecked])

	const resetPasswordClicked = () => {
		setResettingPassword(true)

		if (email) {
			// loginConnector.performPasswordResetRequest(email, password, resetId).then((successRequest) => {
			loginConnector.appPerformResetPasswordRequest(email).then((successRequest) => {
				if (!successRequest) {
					setResetFailed(true)
					setResettingPassword(false)
				} else {
					// window.location.replace(PAGE_URLS.THANK_YOU)
					// TEMP: redirect to log in for new customer who doesn't need to wait for email
					window.location.replace(PAGE_URLS.APP_PASSWORD_RESET)
				}
			})
			// window.location.replace(PAGE_URLS.APP_PASSWORD_RESET)
		} else {
			setResetFailed(true)
			setResettingPassword(false)
		}
	}
	
	return (
		<>
			<div className='section-wrap'>
				<div className='section-content'>
					<div className='log-in-content'>
						<div className='log-in-content-section'>
							<div className='log-in-logo-wrap'>
								<img
									src={'/imgs/logos/logo-main.svg'}
									className="log-in-logo-img"
									alt="Peyto logo"
									onClick={() => {
										window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
									}}
								/>
							</div>
							<div className='log-in-form'>
								<div className='log-in-form-title log-in-form-title-center'>Reset Password</div>
								<div className='log-in-form-caption'>A code will be sent to your email</div>
								<input 
									className='log-in-form-input' 
									type={'email'} 
									placeholder={'Email'} 
									value={email}
									onChange={(event) => {
										setEmail(event.target.value)
									}}
									disabled={resettingPassword}
								/>
								<CtaButton
									label={resettingPassword ? 'Resetting...' : 'Reset'}
									size='medium'
									onClick={() => resetPasswordClicked()}
									fullWidth={true}
									disabled={
										email === '' ||
										resettingPassword
									}
								/>
								{resetFailed && <div className='log-in-form-requirement-txt'>Failed to reset password, please contact support</div>}
								<div className='log-in-line-text-span-wrap'>
									<div className='log-in-line-text-span-wrap-span'>or</div>
								</div>
								<div className='log-in-already-have-account'><a href={PAGE_URLS.APP_LOGIN}>Log In</a></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default AppResetPassword
